import { useState } from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import { ReduxState, Vehicle } from 'types';
import { Api } from 'api';
import { formatMessage } from 'i18n/CurrentLocale';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as vehiclesActions from 'features/vehicles/vehiclesActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins, faTag } from '@fortawesome/free-solid-svg-icons';
import * as Sentry from '@sentry/react';


export const COST_CENTER_CHARACTER_LIMIT = 50;

export const EditCostCenterModal = (props: Props) => {

    const { vehicle, token, companyPublicId } = props;
    const [costCenter, setCostCenter] = useState<string>(vehicle?.costCenter ?? '');
    const [error, setError] = useState<any>();

    const updateCostCenter = async () => {
        try {
            setError(undefined);
            await Api.updateCostCenter(token!, vehicle.localizedLicensePlate, companyPublicId, costCenter);
            props.updateCostCenterCompleted(vehicle, costCenter);
            props.closeModal();
        } catch (e) {
            setError(e);
            Sentry.captureException(e);
        }
    }

    return (
        <div className="panel radius-rectangle full-width-form confirmation-modal">
            <div className="panel-header">
                <h1 className="bold-title">
                    <FontAwesomeIcon icon={faTag} />
                    <FormattedMessage id={vehicle?.costCenter ? 'MODAL_COST_CENTER_TITLE_EDIT' : 'MODAL_COST_CENTER_TITLE_ADD'} />
                </h1>
            </div>
            <div className="panel-content">

                <input type='text' className='text-field'
                    autoFocus
                    value={costCenter}
                    maxLength={COST_CENTER_CHARACTER_LIMIT}
                    placeholder={formatMessage({ id: 'PLACEHOLDER_ADD_COST_CENTER' })}
                    onChange={(e) => setCostCenter(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' ? updateCostCenter() : null}
                />

                <div className='align-right'>
                    <span style={{ color: costCenter?.length < COST_CENTER_CHARACTER_LIMIT ? '#35D38C' : '#D34B35' }}>
                        {`${costCenter?.length}/${COST_CENTER_CHARACTER_LIMIT}`}
                    </span>
                </div>

                {error && (
                    <div className='error-box' style={{ marginBottom: 0, marginTop: '20px' }}>
                        <FormattedMessage id='ERROR_SOMETHING_WENT_WRONG' />
                    </div>
                )}

                <div className="row-7">
                    <div className="col-6">
                        <button className="btn-cancel" onClick={props.closeModal}>
                            <FormattedMessage id="GLOBAL_CANCEL" />
                        </button>
                    </div>
                    <div className="col-6">
                        <button className="btn-green" onClick={updateCostCenter}>
                            <FormattedMessage id='GLOBAL_SAVE' />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


type OwnProps = {
    vehicle: Vehicle
}
type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps & OwnProps;

function mapStateToProps(state: ReduxState) {
    return {
        token: state.auth.token,
        companyPublicId: state.companyDetails?.companyDetails?.publicId
    };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        closeModal: modalWindowActions.closeModal,
        updateCostCenterCompleted: vehiclesActions.updateCostCenterCompleted
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCostCenterModal);